import { useMemo } from 'react';
import useWindowDimensions from 'collaboration-sidebar/hooks/useWindowDimensions';
import { DEFAULT_WIDTH_CUTOFF } from '../constants/sidebar';
export default function useIsScreenWidthBelowThreshold() {
  "use memo";

  const {
    width
  } = useWindowDimensions();
  let t0;
  t0 = width < DEFAULT_WIDTH_CUTOFF;
  const isScreenWidthBelowThreshold = t0;
  return isScreenWidthBelowThreshold;
}